export default "__VITE_ASSET__35d9a674__"